import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";

import { login } from "../../apis/firebase";
import Header from "../utils/Header";

enum LOG_STATE {
  IDLE,
  IN_PROGRESS,
  ERROR,
  SUCCESS,
}

export default function Login() {
  const [formEnabled, enableForm] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [logState, setLogState] = useState<LOG_STATE>(LOG_STATE.IDLE);
  const history = useHistory();

  useEffect(() => {
    const ready = username !== "" && password !== "";

    enableForm(ready);
    setError(null);
  }, [username, password]);

  function renderInputField(
    type: string,
    placeholder: string,
    onUpdate: Function,
    autoFocus = false
  ): void {
    return (
      <input
        type={type}
        placeholder={placeholder}
        onChange={(e) => onUpdate(e.target.value)}
        autoFocus={autoFocus}
        disabled={logState === LOG_STATE.IN_PROGRESS}
      />
    );
  }

  async function onSubmit(e) {
    e.preventDefault();
    try {
      setLogState(LOG_STATE.IN_PROGRESS);
      await login({ username, password: password });
      history.push("/");
    } catch (err) {
      setError(err);
      setLogState(LOG_STATE.ERROR);
    }
  }

  return (
    <div className="layout-narrow mt3">
      <Header className="mt1 mb1" />
      <form onSubmit={onSubmit} className="auth p1">
        {renderInputField("email", "email", setUsername, true)}
        {renderInputField("password", "password", setPassword)}
        <button
          type="submit"
          className="primary"
          disabled={!formEnabled || logState === LOG_STATE.IN_PROGRESS}
        >
          Log in
        </button>
        <LoginError error={error} />
      </form>
      <hr />
      <p className="tac mt1 mb1">
        You don't have an account?
        <br />
        Register <Link to="/register">here</Link>.
      </p>
    </div>
  );
}

function LoginError({
  error,
}: {
  error: { code: string; message: string } | null;
}) {
  let message = "Ops! Error occurred while logging in. Please try again later.";

  if (error !== null) {
    if (error.code === "auth/user-not-found") {
      message = "Email not found.";
    } else if (error.code === "auth/wrong-password") {
      message = "Invalid password.";
    } else if (error.code === "auth/user-disabled") {
      message = "User is disabled.";
    } else if (error.code === "auth/invalid-email") {
      message = "Invalid email.";
    }
    return <div className="error mt1">{message}</div>;
  }
  return null;
}
